import React, { useState, useRef, useCallback, useEffect } from 'react';
import Webcam from 'react-webcam';
import {
  Box,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
  Container,
  Stepper,
  Step,
  StepLabel,
  TextField,
  Button,
  Snackbar,
  Alert,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  InputAdornment,
  Autocomplete,
} from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import BusinessIcon from '@mui/icons-material/Business';

import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import SchoolIcon from '@mui/icons-material/School';
import BadgeIcon from '@mui/icons-material/Badge';
import BorderColorIcon from '@mui/icons-material/BorderColor';

import axios from 'axios';
import Sidebar from '../../components/sidebars/Sidebar_staff';
import TopNav from '../../components/top_bars/TopNav_staff';
import StatisticsCards from '../../components/top_bars/StatisticsCard';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  FormHelperText,
} from '@mui/material';
import { InputLabel, MenuItem, Select } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  PhotoCamera,
  Replay,
  Add,
  Delete,
  Description,
 
 
  Person as PersonIcon,
  Close as CloseIcon,
 
} from '@mui/icons-material';
const steps = [
  'Personal Info',
  'Additional Details',
  'Capture',
  'Education',
  'Experience',
  'Last Employer',
  'Uploads & Security',
  'Salary Account'
];

const initialData = {
  personalInfo: {
    date_of_birth: '',
    marital_status: '',
    country: '',
    state_of_origin: '',
    lga: '',
    department: '',
    residential_address: '',
    hometown_permanent_address: '',
    phone: '',
    status: 'Active',
  },
  jobDetails: {
    health_status: '',
    id_type: '',
    id_number: '',
    next_of_kin_name: '',
    relationship: '',
    next_of_kin_address: '',
    next_of_kin_contact: '',
    status: 'Active',
  },
  capture: {
    image: null,
    status: 'Active',
  },
  education: {
    primary_school_name: '',
    primary_school_address: '',
    secondary_school_name: '',
    secondary_school_address: '',
    tertiary_school_name: '',
    tertiary_school_address: '',
    status: 'Active',
  },
  experience: {
    experience_type: '',
    years_of_experience: '',
    last_workplace_one: '',
    last_workplace_two: '',
    self_evaluation: '',
    salary_expectation: '',
    status: 'Active',
  },
  employment: {
    previous_employer: '',
    job_title: '',
    employment_start_date: '',
    employment_end_date: '',
    reason_for_leaving: '',
    employer_contact_name: '',
    employer_phone: '',
    status: 'Active',
  },
  security_and_upload: {
    guarantor_upload: null,
    staff_signature_upload: null,
    cv_upload: null,
    academic_result_upload: null,
    id_upload: null,
    additional_academic_uploads: [], // Array for additional academic documents (max 3)
    convicted: false,
    security_declaration: false,
    status: 'Active',
  },
 bank: {
  account_number: '',
  account_name: '',
  bank_name: '',
  bank_code: '',
  account_verified: false,
  status: 'Active',
}
};

const HRFormDashboard = () => {
  const [banks, setBanks] = useState([]);
const [verifyingAccount, setVerifyingAccount] = useState(false);
const [banksLoading, setBanksLoading] = useState(false);

  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState(initialData);
  const [completed, setCompleted] = useState({});
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:768px)');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const [userData, setUserData] = useState(null);
  const webcamRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [errorDialog, setErrorDialog] = useState({
    open: false,
    title: '',
    message: '',
    details: []
  });

  const capture = useCallback(() => {
    const image = webcamRef.current.getScreenshot();
    if (!image) {
      setSnackbar({
        open: true,
        message: 'Failed to capture image',
        severity: 'error'
      });
      return;
    }
    setImageSrc(image);
  }, [webcamRef]);

  const handleNext = async () => {
    if (!validateStep(activeStep)) {
      setSnackbar({
        open: true,
        message: 'Please fill all required fields before proceeding',
        severity: 'error'
      });
      return;
    }

    const success = await submitStep(activeStep);

    if (success) {
      setCompleted({ ...completed, [activeStep]: true });

      if (activeStep < steps.length - 1) {
        setActiveStep((prev) => prev + 1);
      } else {
        alert('Onboarding completed successfully!');
        setTimeout(() => {
          navigate('/dashboard');
        }, 3000);
      }
    }
  };

  const fetchUserData = useCallback(async () => {
    try {
      const phone = localStorage.getItem('phoneNumber');
      if (!phone) {
        setSnackbar({
          open: true,
          message: 'Phone number not found in session',
          severity: 'error'
        });
        setTimeout(() => navigate('/dashboard'), 2000);
        return;
      }

      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/get_userstable.php`, {
        params: { phone }
      });

      if (response.data.success) {
        setUserData(response.data.data);
      } else {
        setSnackbar({
          open: true,
          message: response.data.message || 'User not found',
          severity: 'error'
        });
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      setSnackbar({
        open: true,
        message: 'Failed to fetch user data',
        severity: 'error'
      });
      navigate('/dashboard');
    }
  }, [navigate]);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  // Fetch banks on component mount
useEffect(() => {
  const fetchBanks = async () => {
    setBanksLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/verify_bank_account.php?action=get_banks`
      );
      if (response.data.success) {
        setBanks(response.data.data);
      }
    } catch (err) {
      console.error('Error fetching banks:', err);
      // Fallback banks
      setBanks([
        { code: '001', name: 'Access Bank' },
        { code: '002', name: 'Citibank' },
        { code: '003', name: 'Ecobank' },
        { code: '004', name: 'Fidelity Bank' },
        { code: '005', name: 'First Bank of Nigeria' },
        { code: '006', name: 'First City Monument Bank' },
        { code: '007', name: 'Guaranty Trust Bank' },
        { code: '008', name: 'Heritage Bank' },
        { code: '009', name: 'Keystone Bank' },
        { code: '010', name: 'Polaris Bank' },
        { code: '011', name: 'Providus Bank' },
        { code: '012', name: 'Stanbic IBTC Bank' },
        { code: '013', name: 'Standard Chartered Bank' },
        { code: '014', name: 'Sterling Bank' },
        { code: '015', name: 'Suntrust Bank' },
        { code: '016', name: 'Union Bank of Nigeria' },
        { code: '017', name: 'United Bank for Africa' },
        { code: '018', name: 'Unity Bank' },
        { code: '019', name: 'Wema Bank' },
        { code: '020', name: 'Zenith Bank' },
        { code: '021', name: 'Kuda Bank' },
        { code: '022', name: 'Palmpay' },
        { code: '023', name: 'OPAY' },
        { code: '024', name: 'Moniepoint' },
      ]);
    } finally {
      setBanksLoading(false);
    }
  };
  
  fetchBanks();
}, []);

  const handleStep = async (index) => {
    setActiveStep(index);
  };

  const handleChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value
      }
    }));
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const handleCloseErrorDialog = () => {
    setErrorDialog(prev => ({ ...prev, open: false }));
  };

  // Functions for additional academic documents
  const addAdditionalAcademicDocument = () => {
    if (formData.security_and_upload.additional_academic_uploads.length >= 3) {
      setSnackbar({
        open: true,
        message: 'Maximum of 3 additional academic documents allowed',
        severity: 'warning'
      });
      return;
    }
    
    const newDoc = {
      id: Date.now(),
      document_name: '',
      file: null
    };
    setFormData((prev) => ({
      ...prev,
      security_and_upload: {
        ...prev.security_and_upload,
        additional_academic_uploads: [
          ...prev.security_and_upload.additional_academic_uploads,
          newDoc
        ]
      }
    }));
  };

  const removeAdditionalAcademicDocument = (id) => {
    setFormData((prev) => ({
      ...prev,
      security_and_upload: {
        ...prev.security_and_upload,
        additional_academic_uploads: prev.security_and_upload.additional_academic_uploads.filter(
          doc => doc.id !== id
        )
      }
    }));
  };

  const updateAdditionalDocumentName = (id, name) => {
    setFormData((prev) => ({
      ...prev,
      security_and_upload: {
        ...prev.security_and_upload,
        additional_academic_uploads: prev.security_and_upload.additional_academic_uploads.map(doc =>
          doc.id === id ? { ...doc, document_name: name } : doc
        )
      }
    }));
  };

  const updateAdditionalDocumentFile = (id, file) => {
    setFormData((prev) => ({
      ...prev,
      security_and_upload: {
        ...prev.security_and_upload,
        additional_academic_uploads: prev.security_and_upload.additional_academic_uploads.map(doc =>
          doc.id === id ? { ...doc, file } : doc
        )
      }
    }));
  };

  const requiredFields = {
    0: ['date_of_birth', 'marital_status', 'country', 'lga', 'state_of_origin', 'department', 'residential_address', 'hometown_permanent_address'],
    1: ['health_status', 'id_type', 'id_number', 'next_of_kin_name', 'relationship', 'next_of_kin_contact', 'next_of_kin_address'],
    3: ['primary_school_name', 'primary_school_address', 'secondary_school_name', 'secondary_school_address'],
    4: ['experience_type', 'years_of_experience', 'last_workplace_one', 'salary_expectation'],
    6: ['guarantor_upload', 'cv_upload', 'academic_result_upload', 'id_upload', 'staff_signature_upload'],
  };

  const validateStep = (step) => {
    const stepFields = requiredFields[step];
    if (!stepFields) return true;

    const section = Object.keys(formData).find(key =>
      formData[key] && stepFields.every(field => field in formData[key])
    );

    if (!section) return false;

    return stepFields.every(field => {
      const value = formData[section][field];
      return value !== null && value !== undefined && value !== '';
    });
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/get_depts_list.php?t=${Date.now()}`)
      .then((response) => {
        if (response.data.success) {
          setDepartments(response.data.data);
        } else {
          console.error('Failed to fetch departments:', response.data.message);
        }
      })
      .catch((error) => {
        console.error('Error fetching departments:', error);
      });
  }, []);

  const submitStep = async (step) => {
    setLoading(true);

    try {
      let payload = {};
      let endpoint = '';
      let successMessage = '';

      if (step === 0) {
        payload = {
          ...formData.personalInfo,
          phone: localStorage.getItem('phoneNumber') || '',
          surname: `${userData.first_name}` || '',
          other_names: `${userData.other_names}` || '',
          email: `${userData.email}` || ''
        };
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/personalinfo.php`;
        successMessage = 'Personal info submitted successfully';

      } else if (step === 1) {
        payload = {
          ...formData.jobDetails,
          phone: localStorage.getItem('phoneNumber') || ''
        };
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/personalinfo2.php`;
        successMessage = 'Additional info submitted successfully';

      } else if (step === 2) {
        if (!imageSrc) {
          throw new Error("Please capture an image first");
        }
        payload = {
          image: imageSrc,
          phone: localStorage.getItem('phoneNumber') || ''
        };
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/photo_capture.php`;
        successMessage = 'Photo submitted successfully';

      } else if (step === 3) {
        payload = {
          ...formData.education,
          phone: localStorage.getItem('phoneNumber') || ''
        };
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/education.php`;
        successMessage = 'Education info submitted successfully';

      } else if (step === 4) {
        payload = {
          ...formData.experience,
          phone: localStorage.getItem('phoneNumber') || ''
        };
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/job_experience.php`;
        successMessage = 'Job experience info submitted successfully';

      } else if (step === 5) {
        payload = {
          ...formData.employment,
          phone: localStorage.getItem('phoneNumber') || '',
          status: formData.employment.status || 'Active',
        };
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/latest_previous_employment.php`;
        successMessage = 'Last Employer info submitted successfully';

      } else if (step === 6) {
        const convertFileToBase64 = (file) => {
          if (!file) return Promise.resolve(null);
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
              if (typeof reader.result === 'string' && reader.result.startsWith('data:')) {
                resolve(reader.result);
              } else {
                reject(new Error('Invalid file format'));
              }
            };
            reader.onerror = error => reject(error);
            reader.readAsDataURL(file);
          });
        };

        const validateFileSize = (file) => {
          if (file && file.size > 5 * 1024 * 1024) {
            throw new Error(`File ${file.name} exceeds 5MB limit`);
          }
          return true;
        };

        try {
          // Validate main files
          const mainFiles = [
            formData.security_and_upload.guarantor_upload,
            formData.security_and_upload.cv_upload,
            formData.security_and_upload.academic_result_upload,
            formData.security_and_upload.id_upload,
            formData.security_and_upload.staff_signature_upload
          ];
          
          mainFiles.forEach(file => {
            if (file instanceof File) validateFileSize(file);
          });

          // Validate additional academic files
          formData.security_and_upload.additional_academic_uploads.forEach(upload => {
            if (upload.file instanceof File) validateFileSize(upload.file);
          });

          // Convert main files
          const [
            guarantor_upload,
            cv_upload,
            academic_result_upload,
            id_upload,
            staff_signature_upload
          ] = await Promise.all([
            convertFileToBase64(formData.security_and_upload.guarantor_upload),
            convertFileToBase64(formData.security_and_upload.cv_upload),
            convertFileToBase64(formData.security_and_upload.academic_result_upload),
            convertFileToBase64(formData.security_and_upload.id_upload),
            convertFileToBase64(formData.security_and_upload.staff_signature_upload)
          ]);

          // Convert additional academic files
          const additionalAcademicUploads = await Promise.all(
            formData.security_and_upload.additional_academic_uploads.map(async (upload) => ({
              id: upload.id,
              document_name: upload.document_name,
              file: await convertFileToBase64(upload.file)
            }))
          );

          payload = {
            phone: localStorage.getItem('phoneNumber') || '',
            status: formData.security_and_upload.status || 'Active',
            convicted: formData.security_and_upload.convicted || false,
            security_declaration: formData.security_and_upload.security_declaration || false,
            guarantor_upload,
            cv_upload,
            academic_result_upload,
            id_upload,
            staff_signature_upload,
            additional_academic_uploads: JSON.stringify(additionalAcademicUploads)
          };

          endpoint = `${process.env.REACT_APP_API_BASE_URL}/security_and_uploads.php`;
          successMessage = 'Security info and uploads submitted successfully';
        } catch (error) {
          throw new Error(`File processing error: ${error.message}`);
        }
    } else if (step === 7) {
    // Make sure account is verified before submission
    if (!formData.bank.account_verified) {
        setSnackbar({
            open: true,
            message: 'Please verify your bank account before submitting',
            severity: 'error'
        });
        return false;
    }
    
    payload = {
        ...formData.bank,
        phone: localStorage.getItem('phoneNumber') || '',
        status: formData.employment.status || 'Active',
    };
    endpoint = `${process.env.REACT_APP_API_BASE_URL}/salary.php`;
    successMessage = 'Bank info submitted successfully';
} else {
        throw new Error(`Unsupported step: ${step}`);
      }

      Object.keys(payload).forEach(key => {
        if (payload[key] === null || payload[key] === undefined) {
          payload[key] = '';
        }
      });

      const response = await axios.post(endpoint, payload, {
        headers: { 'Content-Type': 'application/json' },
        validateStatus: status => status < 500
      });

    if (response.data.success) {
    setSnackbar({
        open: true,
        message: successMessage,
        severity: 'success'
    });
    return true;
} else {
    // Handle existing record case
    if (response.status === 409 || response.data.existing_record) {
        setErrorDialog({
            open: true,
            title: 'Salary Record Already Exists',
            message: response.data.message,
            details: [
                `Existing Account: ${response.data.existing_record?.account_number}`,
                `Existing Bank: ${response.data.existing_record?.bank_name}`,
                `Current Salary: ₦${response.data.existing_record?.salary_amount?.toLocaleString() || '0'}`
            ]
        });
    } else {
        const errorDetails = [];
        if (response.data.errors?.missing_fields) {
            errorDetails.push(`Missing fields: ${response.data.errors.missing_fields.join(', ')}`);
        }
        
        setErrorDialog({
            open: true,
            title: 'Submission Error',
            message: response.data.message || 'Please correct the following issues:',
            details: errorDetails
        });
    }
    return false;
}
    } catch (error) {
      console.error('Submission error:', error);
      let errorMessage = 'An unexpected error occurred';
      if (error.response) {
        errorMessage = error.response.data.message || `Server error (${error.response.status})`;
      } else if (error.request) {
        errorMessage = 'Network error - please check your connection';
      }
      setErrorDialog({
        open: true,
        title: 'Submission Failed',
        message: errorMessage,
        details: []
      });
      return false;
    } finally {
      setLoading(false);
    }
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                required
                label="Date of Birth"
                type="date"
                InputLabelProps={{ shrink: true }}
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.personalInfo.date_of_birth}
                onChange={(e) => handleChange('personalInfo', 'date_of_birth', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth required sx={{ minWidth: '550px' }}>
                <InputLabel id="marital-status-label">Marital Status</InputLabel>
                <Select
                  labelId="marital-status-label"
                  id="marital-status"
                  value={formData.personalInfo.marital_status}
                  label="Marital Status"
                  onChange={(e) => handleChange('personalInfo', 'marital_status', e.target.value)}
                >
                  <MenuItem value=""><em>Select</em></MenuItem>
                  <MenuItem value="Single">Single</MenuItem>
                  <MenuItem value="Married">Married</MenuItem>
                  <MenuItem value="Divorced">Divorced</MenuItem>
                  <MenuItem value="Widowed">Widowed</MenuItem>
                  <MenuItem value="Separated">Separated</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                required
                label="Country"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.personalInfo.country}
                onChange={(e) => handleChange('personalInfo', 'country', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                required
                label="State of Origin"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.personalInfo.state_of_origin}
                onChange={(e) => handleChange('personalInfo', 'state_of_origin', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                required
                label="Local Government Area (LGA)"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.personalInfo.lga}
                onChange={(e) => handleChange('personalInfo', 'lga', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth required sx={{ minWidth: '550px' }}>
                <InputLabel id="department-label">Department</InputLabel>
                <Select
                  labelId="department-label"
                  id="department"
                  value={formData.personalInfo.department}
                  label="Department"
                  onChange={(e) => handleChange('personalInfo', 'department', e.target.value)}
                >
                  <MenuItem value=""><em>Select Department</em></MenuItem>
                  {departments.map((dept) => (
                    <MenuItem key={dept.id} value={dept.departments}>
                      {dept.departments}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                label="Residential Address"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.personalInfo.residential_address}
                onChange={(e) => handleChange('personalInfo', 'residential_address', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                label="Hometown / Permanent Address"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.personalInfo.hometown_permanent_address}
                onChange={(e) => handleChange('personalInfo', 'hometown_permanent_address', e.target.value)}
              />
            </Grid>
          </Grid>
        );

      case 1:
        return (
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                select
                label="Health Status"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.jobDetails.health_status}
                onChange={(e) => handleChange('jobDetails', 'health_status', e.target.value)}
              >
                <MenuItem value="">Select Health Status</MenuItem>
                <MenuItem value="Healthy">Healthy</MenuItem>
                <MenuItem value="Disabled">Disabled</MenuItem>
                <MenuItem value="Chronic Illness">Chronic Illness</MenuItem>
                <MenuItem value="Visually Impaired">Visually Impaired</MenuItem>
                <MenuItem value="Hearing Impaired">Hearing Impaired</MenuItem>
                <MenuItem value="Mental Health Condition">Mental Health Condition</MenuItem>
                <MenuItem value="Recovering from Injury">Recovering from Injury</MenuItem>
                <MenuItem value="Terminal Illness">Terminal Illness</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                select
                label="ID Type"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.jobDetails.id_type}
                onChange={(e) => handleChange('jobDetails', 'id_type', e.target.value)}
              >
                <MenuItem value="">Select ID Type</MenuItem>
                <MenuItem value="National ID">National ID (NIN)</MenuItem>
                <MenuItem value="Voter's Card">Voter's Card (PVC)</MenuItem>
                <MenuItem value="Driver's License">Driver’s License</MenuItem>
                <MenuItem value="International Passport">International Passport</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="ID Number"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.jobDetails.id_number}
                onChange={(e) => handleChange('jobDetails', 'id_number', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Next of Kin Name"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.jobDetails.next_of_kin_name}
                onChange={(e) => handleChange('jobDetails', 'next_of_kin_name', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                select
                label="Relationship"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.jobDetails.relationship}
                onChange={(e) => handleChange('jobDetails', 'relationship', e.target.value)}
              >
                <MenuItem value="">Select Relationship</MenuItem>
                <MenuItem value="Spouse">Spouse</MenuItem>
                <MenuItem value="Parent">Parent</MenuItem>
                <MenuItem value="Sibling">Sibling</MenuItem>
                <MenuItem value="Child">Child</MenuItem>
                <MenuItem value="Uncle">Uncle</MenuItem>
                <MenuItem value="Aunt">Aunt</MenuItem>
                <MenuItem value="Cousin">Cousin</MenuItem>
                <MenuItem value="Friend">Friend</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Next of Kin Address"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.jobDetails.next_of_kin_address}
                onChange={(e) => handleChange('jobDetails', 'next_of_kin_address', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Next of Kin Contact"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.jobDetails.next_of_kin_contact}
                onChange={(e) => handleChange('jobDetails', 'next_of_kin_contact', e.target.value)}
              />
            </Grid>
          </Grid>
        );

      case 2:
        return (
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} sm={6} md={4}>
              <Paper elevation={3} sx={{ p: 2, textAlign: 'center' }}>
                <Typography variant="subtitle1" gutterBottom>
                  Camera
                </Typography>
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  videoConstraints={{ width: 240, height: 320, facingMode: 'user' }}
                  style={{
                    borderRadius: '8px',
                    border: '1px solid #ccc',
                    width: '280px',
                    height: '323px',
                    objectFit: 'cover',
                    marginBottom: '1rem',
                  }}
                />
                <Box display="flex" justifyContent="center" gap={1}>
                  <Button
                    variant="contained"
                    size="small"
                    startIcon={<PhotoCamera />}
                    onClick={capture}
                    sx={{
                      mt: 3,
                      textTransform: 'none',
                      fontWeight: 'bold',
                      borderRadius: 2,
                      backgroundColor: '#C84646',
                      '&:hover': {
                        backgroundColor: '#b33c3c',
                      },
                    }}
                  >
                    Capture
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    size="small"
                    startIcon={<Replay />}
                    onClick={() => setImageSrc(null)}
                    disabled={!imageSrc}
                  >
                    Reset
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Paper elevation={3} sx={{ p: 2, textAlign: 'center' }}>
                <Typography variant="subtitle1" gutterBottom>
                  Captured Passport Photo
                </Typography>
                {imageSrc ? (
                  <img
                    src={imageSrc}
                    alt="Passport"
                    style={{
                      width: '280px',
                      height: '323px',
                      borderRadius: '8px',
                      border: '1px solid #ccc',
                      objectFit: 'cover',
                    }}
                  />
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    No image captured yet.
                  </Typography>
                )}
              </Paper>
            </Grid>
          </Grid>
        );

      case 3:
        return (
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Primary School Name"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.education.primary_school_name}
                onChange={(e) => handleChange('education', 'primary_school_name', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Primary School Address"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.education.primary_school_address}
                onChange={(e) => handleChange('education', 'primary_school_address', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Secondary School Name"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.education.secondary_school_name}
                onChange={(e) => handleChange('education', 'secondary_school_name', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Secondary School Address"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.education.secondary_school_address}
                onChange={(e) => handleChange('education', 'secondary_school_address', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Tertiary Institution Name"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.education.tertiary_school_name}
                onChange={(e) => handleChange('education', 'tertiary_school_name', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Tertiary Institution Address"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.education.tertiary_school_address}
                onChange={(e) => handleChange('education', 'tertiary_school_address', e.target.value)}
              />
            </Grid>
          </Grid>
        );

      case 4:
        return (
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Experience Type"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.experience.experience_type}
                onChange={(e) => handleChange('experience', 'experience_type', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Years of Experience"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.experience.years_of_experience}
                onChange={(e) => handleChange('experience', 'years_of_experience', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Last Workplace One"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.experience.last_workplace_one}
                onChange={(e) => handleChange('experience', 'last_workplace_one', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Last Workplace Two"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.experience.last_workplace_two}
                onChange={(e) => handleChange('experience', 'last_workplace_two', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Self Evaluation"
                multiline
                rows={4}
                fullWidth
                sx={{ minWidth: '550px' }}
                placeholder="Write a short note about yourself covering general education/Knowledge, Technical Ability (Job skill required), emotional stability, enthusiasm, ability to relate well with others, appearance, health, command of English, sincerity and honesty."
                value={formData.experience.self_evaluation}
                onChange={(e) => handleChange('experience', 'self_evaluation', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Salary Expectation"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.experience.salary_expectation}
                onChange={(e) => handleChange('experience', 'salary_expectation', e.target.value)}
              />
            </Grid>
          </Grid>
        );

      case 5:
        return (
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Last Employer"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.employment.previous_employer}
                onChange={(e) => handleChange('employment', 'previous_employer', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Job Title"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.employment.job_title}
                onChange={(e) => handleChange('employment', 'job_title', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Employment Start Date"
                type="date"
                fullWidth
                sx={{ minWidth: '550px' }}
                InputLabelProps={{ shrink: true }}
                value={formData.employment.employment_start_date}
                onChange={(e) => handleChange('employment', 'employment_start_date', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Employment End Date"
                type="date"
                fullWidth
                sx={{ minWidth: '550px' }}
                InputLabelProps={{ shrink: true }}
                value={formData.employment.employment_end_date}
                onChange={(e) => handleChange('employment', 'employment_end_date', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Reason for Leaving"
                multiline
                rows={3}
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.employment.reason_for_leaving}
                onChange={(e) => handleChange('employment', 'reason_for_leaving', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Employer Contact Name"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.employment.employer_contact_name}
                onChange={(e) => handleChange('employment', 'employer_contact_name', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Employer Phone"
                fullWidth
                sx={{ minWidth: '550px' }}
                value={formData.employment.employer_phone}
                onChange={(e) => handleChange('employment', 'employer_phone', e.target.value)}
              />
            </Grid>
          </Grid>
        );

      case 6:
        return (
          <Grid container spacing={3}>
            {/* Main File Upload Buttons */}
            {[
              { name: 'guarantor_upload', label: 'Guarantor Upload', icon: <AssignmentIndIcon /> },
              { name: 'cv_upload', label: 'CV Upload', icon: <DescriptionIcon /> },
              { name: 'academic_result_upload', label: 'Academic Result Upload', icon: <SchoolIcon /> },
              { name: 'id_upload', label: 'ID Upload', icon: <BadgeIcon /> },
              { name: 'staff_signature_upload', label: 'Signature Upload', icon: <BorderColorIcon /> }
            ].map((file) => (
              <Grid item xs={12} md={6} lg={4} key={file.name}>
                <Box display="flex" flexDirection="column" alignItems="flex-start">
                  <Button
                    variant="outlined"
                    component="label"
                    fullWidth
                    startIcon={file.icon}
                    sx={{
                      justifyContent: 'flex-start',
                      padding: '12px 16px',
                      textTransform: 'none',
                      fontSize: '1rem'
                    }}
                  >
                    {file.label}
                    <input
                      type="file"
                      hidden
                      accept=".jpg,.jpeg,.png,.pdf,.docx"
                      onChange={(e) => {
                        if (e.target.files && e.target.files[0]) {
                          handleChange(
                            'security_and_upload',
                            file.name,
                            e.target.files[0]
                          );
                        }
                      }}
                    />
                  </Button>
                  {formData.security_and_upload[file.name] && (
                    <Typography variant="caption" sx={{ mt: 1 }}>
                      Selected: {formData.security_and_upload[file.name].name}
                    </Typography>
                  )}
                </Box>
              </Grid>
            ))}

            {/* Additional Academic Documents Section */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mt: 3, mb: 2, color: '#C84646' }}>
                Additional Academic Documents (Optional)
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Upload additional academic certificates or documents (e.g., Professional Certifications, Diplomas, etc.) - Maximum 3 documents
              </Typography>
            </Grid>

            {formData.security_and_upload.additional_academic_uploads.map((doc, index) => (
              <Grid item xs={12} key={doc.id}>
                <Paper elevation={2} sx={{ p: 3, mb: 2, position: 'relative' }}>
                  <IconButton
                    size="small"
                    color="error"
                    sx={{ position: 'absolute', top: 8, right: 8 }}
                    onClick={() => removeAdditionalAcademicDocument(doc.id)}
                  >
                    <Delete />
                  </IconButton>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Document Name/Description"
                        fullWidth
                        placeholder="e.g., Professional Certification, Diploma, etc."
                        value={doc.document_name}
                        onChange={(e) => updateAdditionalDocumentName(doc.id, e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                        startIcon={<Description />}
                        sx={{ height: '56px' }}
                      >
                        Choose File
                        <input
                          type="file"
                          hidden
                          accept=".jpg,.jpeg,.png,.pdf"
                          onChange={(e) => {
                            if (e.target.files && e.target.files[0]) {
                              updateAdditionalDocumentFile(doc.id, e.target.files[0]);
                            }
                          }}
                        />
                      </Button>
                      {doc.file && (
                        <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
                          Selected: {doc.file.name}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            ))}

            <Grid item xs={12}>
              <Button
                variant="outlined"
                startIcon={<Add />}
                onClick={addAdditionalAcademicDocument}
                disabled={formData.security_and_upload.additional_academic_uploads.length >= 3}
                sx={{ mt: 1 }}
              >
                Add Additional Academic Document
              </Button>
              {formData.security_and_upload.additional_academic_uploads.length >= 3 && (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                  Maximum of 3 additional documents reached
                </Typography>
              )}
            </Grid>

            {/* Convicted Radio */}
            <Grid item xs={12}>
              <FormControl component="fieldset" fullWidth>
                <FormLabel component="legend">Have you ever been convicted?</FormLabel>
                <RadioGroup
                  row
                  value={formData.security_and_upload.convicted ? 'yes' : 'no'}
                  onChange={(e) =>
                    handleChange(
                      'security_and_upload',
                      'convicted',
                      e.target.value === 'yes'
                    )
                  }
                >
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Grid>

            {/* Security Declaration Radio */}
            <Grid item xs={12}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  Security Declaration
                </Typography>
                <Typography variant="body1" sx={{ fontSize: '1.05rem', color: 'text.secondary' }}>
                  I hereby affirm that all the information provided in this document is true, accurate, and complete to the best of my knowledge. I acknowledge that providing false, misleading, or incomplete information, or failing to disclose any required details, may result in disciplinary action, including but not limited to the termination of my employment.
                </Typography>
              </Box>
              <FormControl component="fieldset" fullWidth>
                <FormLabel component="legend">Do you agree to the security declaration?</FormLabel>
                <RadioGroup
                  row
                  value={formData.security_and_upload.security_declaration ? 'yes' : 'no'}
                  onChange={(e) =>
                    handleChange(
                      'security_and_upload',
                      'security_declaration',
                      e.target.value === 'yes'
                    )
                  }
                >
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        );

      case 7:
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Alert severity="info" sx={{ mb: 2, borderRadius: 2 }}>
          <strong>Bank Account Verification</strong><br />
          Enter your account number and select your bank to automatically verify and populate your account details.
        </Alert>
      </Grid>
      
      <Grid item xs={12} md={6}>
       <FormControl fullWidth sx={{ minWidth: 150 }}>
  <InputLabel>Select Bank</InputLabel>
  <Select
    value={formData.bank.bank_code || ''}
    label="Select Bank"
    onChange={(e) => {
      const selectedBank = banks.find(b => b.code === e.target.value);
      handleChange('bank', 'bank_code', e.target.value);
      handleChange('bank', 'bank_name', selectedBank?.name || '');
      handleChange('bank', 'account_verified', false);
      handleChange('bank', 'account_name', '');
    }}
  >
    <MenuItem value="">Select Bank</MenuItem>
    {banks.map((bank) => (
      <MenuItem key={bank.code} value={bank.code}>
        {bank.name}
      </MenuItem>
    ))}
  </Select>
</FormControl>
      </Grid>
      
      <Grid item xs={12} md={6}>
        <TextField
          label="Account Number"
          fullWidth
          value={formData.bank.account_number}
          onChange={async (e) => {
            const value = e.target.value.replace(/\D/g, '').slice(0, 10);
            handleChange('bank', 'account_number', value);
            handleChange('bank', 'account_verified', false);
            handleChange('bank', 'account_name', '');
            
            // Auto-verify when 10 digits are entered
            if (value.length === 10 && formData.bank.bank_code) {
              setVerifyingAccount(true);
              try {
                const response = await axios.get(
                  `${process.env.REACT_APP_API_BASE_URL}/verify_bank_account.php`,
                  {
                    params: {
                      account_number: value,
                      bank_code: formData.bank.bank_code
                    }
                  }
                );
                
                if (response.data.success) {
                  handleChange('bank', 'account_name', response.data.data.account_name);
                  handleChange('bank', 'account_verified', true);
                  setSnackbar({
                    open: true,
                    message: `Account verified: ${response.data.data.account_name}`,
                    severity: 'success'
                  });
                } else {
                  handleChange('bank', 'account_verified', false);
                  setSnackbar({
                    open: true,
                    message: response.data.message || 'Account verification failed',
                    severity: 'error'
                  });
                }
              } catch (err) {
                console.error('Verification error:', err);
                setSnackbar({
                  open: true,
                  message: 'Failed to verify account. Please check the account number.',
                  severity: 'error'
                });
              } finally {
                setVerifyingAccount(false);
              }
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {verifyingAccount ? (
                  <CircularProgress size={20} />
                ) : formData.bank.account_verified ? (
                  <VerifiedIcon sx={{ color: '#4caf50' }} />
                ) : (
                  <AccountBalanceIcon sx={{ color: '#C84646' }} />
                )}
              </InputAdornment>
            ),
          }}
          helperText={
            formData.bank.account_number?.length === 10 && !formData.bank.account_verified && !verifyingAccount
              ? "Account not verified. Please check the account number."
              : "Enter 10-digit account number"
          }
          error={
            formData.bank.account_number?.length === 10 && 
            !formData.bank.account_verified && 
            !verifyingAccount
          }
        />
      </Grid>
      
      <Grid item xs={12} md={6}>
        <TextField
          label="Account Name"
          fullWidth
          value={formData.bank.account_name}
          disabled
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PersonIcon sx={{ color: '#C84646' }} />
              </InputAdornment>
            ),
          }}
          helperText={formData.bank.account_verified ? "✓ Verified account name" : "Will auto-populate after verification"}
        />
      </Grid>
      
      <Grid item xs={12} md={6}>
        <TextField
          label="Bank Name"
          fullWidth
          value={formData.bank.bank_name}
          disabled
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <BusinessIcon  sx={{ color: '#C84646' }} />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      
      {formData.bank.account_verified && (
        <Grid item xs={12}>
          <Alert severity="success" icon={<VerifiedIcon />} sx={{ borderRadius: 2 }}>
            <strong>Account Verified!</strong> Your account has been successfully verified.
            The account name has been auto-populated.
          </Alert>
        </Grid>
      )}
    </Grid>
  );      default:
        return 'Unknown Step';
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          ml: isMobile ? 0 : sidebarOpen ? 30 : 5,
          mt: 0,
          maxWidth: '1400px',
          mx: 'auto'
        }}
      >
        <TopNav
          onLogout={() => {
            localStorage.removeItem('authToken');
            localStorage.removeItem('userProfile');
          }}
          onNotificationClick={() => alert('You have new notifications!')}
          toggleSidebar={toggleSidebar}
        />

        <Box sx={{ mt: 2 }}>
          <StatisticsCards />
        </Box>

        <Grid container spacing={3} sx={{ mt: 3 }}>
          <Grid item xs={12}>
            <Paper
              elevation={4}
              sx={{
                p: 3,
                width: '100%',
                borderRadius: 4,
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)'
              }}
            >
              <Typography
                variant="h6"
                component="h2"
                align="left"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                  mb: 2,
                  color: 'info.dark',
                  letterSpacing: 0.5
                }}
              >
                Onboarding for
                {userData && (
                  <Typography
                    variant="subtitle1"
                    component="span"
                    sx={{
                      ml: 2,
                      fontWeight: 'bold',
                      color: '#4A0000',
                      textTransform: 'uppercase'
                    }}
                  >
                    {`${userData.first_name} ${userData.other_names}`.toUpperCase()}
                  </Typography>
                )}
              </Typography>
              <Container>
                <Stepper activeStep={activeStep} alternativeLabel>
                  {steps.map((label, index) => (
                    <Step key={label} completed={completed[index]}>
                      <StepLabel
                        StepIconProps={{
                          onClick: () => handleStep(index),
                          style: { cursor: 'pointer' }
                        }}
                      >
                        {label}
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>

                <Box sx={{ mt: 3 }}>{renderStepContent(activeStep)}</Box>

                <Box
                  sx={{
                    mt: 4,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    px: 2
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    disabled={loading || (activeStep === 6 && !formData.security_and_upload.security_declaration)}
                    sx={{
                      px: 6,
                      py: 1.8,
                      fontWeight: 600,
                      fontSize: '17px',
                      borderRadius: '12px',
                      backgroundColor: 'primary.main',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                      '&:hover': {
                        backgroundColor: 'primary.dark'
                      }
                    }}
                  >
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      activeStep === steps.length - 1 ? 'Submit' : 'Next'
                    )}
                  </Button>
                </Box>
              </Container>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Dialog open={errorDialog.open} onClose={handleCloseErrorDialog}>
        <DialogTitle>{errorDialog.title}</DialogTitle>
        <DialogContent>
          <Typography>{errorDialog.message}</Typography>
          {errorDialog.details.length > 0 && (
            <ul>
              {errorDialog.details.map((detail, index) => (
                <li key={index}>{detail}</li>
              ))}
            </ul>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseErrorDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default HRFormDashboard;